<div
  #playerRoot
  class="waveform-player-wrapper"
  tabindex="0"
  (keydown)="onKeydown($event)"
  (pointerdown)="playerRoot.focus()"
  [class.waveform-player-wrapper--controls-on-top]="controlsOnTop()"
  [class.waveform-player-wrapper--disabled]="disabled()"
>
  <div class="waveform-player-stage">
    <!-- WaveSurfer's media element; only shown for video files, but also plays audio files -->
    <video
      #mediaEl
      class="waveform-player-video"
      [class.waveform-player-video--hidden]="!showVideo()"
      [class.waveform-player-video--compact]="compact()"
      playsinline
      preload="auto"
    ></video>

    <div class="waveform-player-canvas">
      <div
        #waveformEl
        id="waveform"
        class="waveform-player-container"
        [class.waveform-player-container--compact]="compact()"
      >
      </div>

      @if (isLoading()) {
        <div class="waveform-player-skeleton skeleton" aria-hidden="true"></div>
        @if (loadProgress() > 0) {
          <div class="waveform-player-progress">
            <mat-progress-bar
              mode="determinate"
              [value]="loadProgress()"
              [attr.aria-label]="'TRANS__SEARCH__LOADING_INFO' | translate"
            ></mat-progress-bar>
            <span class="waveform-player-progress__percent" aria-hidden="true">{{ loadProgress() }} %</span>
          </div>
        }
      }

      @if (waveformLoading() && loadProgress() > 0) {
        <div class="waveform-player-progress waveform-player-progress--background">
          <span aria-hidden="true">{{ 'TRANS__AUDIO_PLAYER__LOADING_WAVEFORM' | translate }}</span>
          <mat-progress-bar
            mode="determinate"
            [value]="loadProgress()"
            [attr.aria-label]="'TRANS__AUDIO_PLAYER__LOADING_WAVEFORM' | translate"
          ></mat-progress-bar>
          <span class="waveform-player-progress__percent" aria-hidden="true">{{ loadProgress() }} %</span>
        </div>
      }

      @if (waveformUnavailable()) {
        <div class="waveform-unavailable-note" role="status">
          <mat-icon>info</mat-icon>
          {{ 'TRANS__AUDIO_PLAYER__WAVEFORM_UNAVAILABLE' | translate }}
        </div>
      }

      @if (loadError()) {
        <div class="waveform-player-error" role="alert">
          <mat-icon>error</mat-icon>
          {{ 'TRANS__AUDIO_PLAYER__LOAD_FAILED' | translate }}
        </div>
      }
    </div>
  </div>

  <div class="waveform-player-controls">
    <div class="waveform-player-controls__playback">
      @for (btn of playbackControlButtons(); track $index) {
        @if (!btn?.hidden) {
          <button
            mat-icon-button
            [matTooltip]="!!btn?.tooltip ? (btn.tooltip | translate) : null"
            matTooltipPosition="above"
            [class.mat-icon-button-filled-primary]="btn.primary && this.isLoaded() && !disabled() && !btn.disabled"
            [disabled]="!this.isLoaded() || disabled() || (btn?.disabled ?? false)"
            (click)="btn.action()"
          >
            <mat-icon>{{ btn.icon }}</mat-icon>
          </button>
        }
      }
      <div class="waveform-player-controls__timecode">
        {{ formatTime(currentTime()) }} / {{ formatTime(duration()) }}
      </div>
    </div>
    <div class="waveform-player-controls__canvas">
      @if (!compact()) {
        <label [class.disabled]="!isLoaded() || disabled()">
          <span>{{ 'TRANS__MEDIA_CAROUSEL__ZOOM' | translate }}:</span>
          <input
            type="range"
            min="0"
            max="1000"
            [value]="zoomLevel()"
            (input)="onZoomChange($event)"
            [disabled]="!isLoaded() || disabled()"
          />
        </label>
      }
      @for (btn of canvasControlButtons(); track $index) {
        <button
          mat-icon-button
          [class.mat-icon-button-filled-primary]="btn.primary"
          [disabled]="btn?.disabled ?? false"
          (click)="btn.action()"
        >
          <mat-icon>{{ btn.icon }}</mat-icon>
        </button>
      }
    </div>
  </div>
</div>
